export enum SacRequestTypes {
  LIST = '@sacRequest/LIST',
  LIST_SUCCESS = '@sacRequest/LIST_SUCCESS',
  LIST_FAILED = '@sacRequest/LIST_FAILED',
}
